import React from "react";
import "./Breadcrumbs.scss";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
const breadcrumbsStructureData = (listOfItems) => {
    const schema = document.createElement("script");
    const items = listOfItems.filter(f=>f.url).map((element, index) => {
        return {
            "@type": "ListItem",
            "position": index,
            "name": element.name,
            "item": element.url
        };
    });
    const schemaStructure = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items
    };
    schema.type = "application/ld+json";
    schema.text = JSON.stringify([schemaStructure]);
    document.querySelector("head").appendChild(schema);
};

const Breadcrumbs = props => {
    const list = [
        {
            url: ConfigurationHelper.getGlobalConfiguration().sub_folder+"/",
            name: "Home",
            active: props.isHomePage
        },
        ...props.breadcrumbsList
    ];
    const className = props.className ? props.className : "";

    if(props.renderStructureData)
        breadcrumbsStructureData(list);

    return (
        <div className={"container "+className}>
            <div className={"row"}>
                <div className="col-7 col-sm-8 col-md-9">
                    <ul className={"tvp-breadcrumbs "+(props.keepOnMobile ? "keep-on-mobile": "")}>
                        {list.map((item, index) => {

                            return (<li itemScope itemType="http://data-vocabulary.org/Breadcrumb"
                                        className={item.hideItemOnMobile ? "hide-item-mobile": ""}
                                        key={index}>
                                {item.active ?
                                    <span >
                                        <span className={(item.active ? "active" : "")} >{item.name}</span>
                                    </span> : item.url ?
                                        <a itemProp="url" href={item.url}>
                                            <span className={item.highlightMobile ? "highlight" : ""} itemProp="title">{item.name}</span>
                                        </a>:
                                        <span >
                                        <span className={(item.active ? "active" : "")} >{item.name}</span>
                                    </span>
                                }
                            </li>)
                        })}
                    </ul>
                </div>
                {ConfigurationHelper.isAmbassadorProgramEnabled() && <div className={"col-5 col-sm-4 col-md-3 sign-in-container"}>
                    <div className={"sign-in "+(props.keepOnMobile ? "keep-on-mobile": "")}>
                        <a href={TVSite.sub_folder+"/sign-in"}>
                            <span className={"ambassador"}>Ambassador</span> Sign In
                        </a>
                    </div>
                </div>}
            </div>
        </div>

    );
};

Breadcrumbs.defaultProps = {
    breadcrumbsList: [],
    isHomePage: false,
    keepOnMobile: false,
    renderStructureData : true
};
export default Breadcrumbs;